"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLimitPricePanel = exports.useLimitPercentButton = exports.useInvertLimit = exports.useLimitResetButton = exports.useIsLimitInverted = exports.useLimitTokens = exports.useLimitPercentList = exports.useLimitInput = exports.useOnLimitPercentageClick = void 0;
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var react_1 = require("react");
var actions_1 = require("../../context/actions");
var context_1 = require("../../context/context");
var lib_1 = require("../../hooks/lib");
var utils_1 = require("../../utils");
var useOnLimitPercentageClick = function () {
    var marketPrice = (0, lib_1.useMarketPrice)().marketPrice;
    var _a = (0, context_1.useTwapContext)(), state = _a.state, dstToken = _a.dstToken;
    var onChange = actions_1.stateActions.useOnLimitChange();
    var onResetCustomLimit = actions_1.stateActions.useResetCustomLimit();
    var isInvertedLimitPrice = state.isInvertedLimitPrice;
    return (0, react_1.useCallback)(function (percent) {
        if ((0, bignumber_js_1.default)(percent).isZero()) {
            onResetCustomLimit();
            return;
        }
        var p = (0, bignumber_js_1.default)(percent || 0)
            .div(100)
            .plus(1)
            .toString();
        var price = (0, utils_1.amountUiV2)(dstToken === null || dstToken === void 0 ? void 0 : dstToken.decimals, marketPrice);
        if (isInvertedLimitPrice) {
            price = (0, bignumber_js_1.default)(1)
                .div(price || "0")
                .toString();
        }
        var value = (0, bignumber_js_1.default)(price || "0")
            .times(p)
            .toString();
        onChange((0, utils_1.formatDecimals)(value), percent);
    }, [marketPrice, onChange, onResetCustomLimit, dstToken, isInvertedLimitPrice]);
};
exports.useOnLimitPercentageClick = useOnLimitPercentageClick;
var useLimitInput = function () {
    var _a = (0, context_1.useTwapContext)(), state = _a.state, dstToken = _a.dstToken;
    var isInvertedLimitPrice = state.isInvertedLimitPrice, isCustomLimitPrice = state.isCustomLimitPrice, customLimitPrice = state.customLimitPrice;
    var _b = (0, lib_1.useLimitPrice)(), priceUi = _b.priceUi, isLoading = _b.isLoading;
    var onChange = actions_1.stateActions.useOnLimitChange();
    var value = (0, react_1.useMemo)(function () {
        if (isCustomLimitPrice) {
            return customLimitPrice;
        }
        var res = priceUi;
        if (isInvertedLimitPrice) {
            res = (0, bignumber_js_1.default)(1)
                .div(res || 0)
                .toString();
        }
        return (0, utils_1.formatDecimals)(res);
    }, [customLimitPrice, isCustomLimitPrice, isInvertedLimitPrice, priceUi, dstToken]);
    return {
        value: value || "",
        onChange: onChange,
        isLoading: isLoading,
    };
};
exports.useLimitInput = useLimitInput;
var defaultPercent = [1, 5, 10];
var useList = function () {
    var isInvertedLimitPrice = (0, context_1.useTwapContext)().state.isInvertedLimitPrice;
    return (0, react_1.useMemo)(function () {
        if (isInvertedLimitPrice) {
            return defaultPercent.map(function (it) { return -it; }).map(function (it) { return it.toString(); });
        }
        return defaultPercent.map(function (it) { return it.toString(); });
    }, [isInvertedLimitPrice]);
};
var useCustomPercent = function () {
    var priceDeltaPercentage = (0, lib_1.useLimitPricePercentDiffFromMarket)();
    var _a = (0, context_1.useTwapContext)().state, inverted = _a.isInvertedLimitPrice, limitPricePercent = _a.limitPricePercent;
    var formatted = useList();
    var custom = (0, react_1.useMemo)(function () {
        if ((0, bignumber_js_1.default)(priceDeltaPercentage).isZero()) {
            return false;
        }
        if ((0, bignumber_js_1.default)(limitPricePercent || 0).gt(0)) {
            return false;
        }
        if (limitPricePercent && formatted.includes(limitPricePercent)) {
            return false;
        }
        if (priceDeltaPercentage && formatted.includes(priceDeltaPercentage)) {
            return false;
        }
        return true;
    }, [priceDeltaPercentage, limitPricePercent, formatted]);
    return custom ? priceDeltaPercentage : undefined;
};
var useLimitPercentList = function () {
    var priceDeltaPercentage = (0, lib_1.useLimitPricePercentDiffFromMarket)();
    var formatted = useList();
    var custom = useCustomPercent();
    return (0, react_1.useMemo)(function () {
        if (!custom) {
            return __spreadArray(["0"], formatted, true);
        }
        return formatted;
    }, [formatted, custom, priceDeltaPercentage]);
};
exports.useLimitPercentList = useLimitPercentList;
var useLimitTokens = function () {
    var _a = (0, context_1.useTwapContext)(), t = _a.translations, state = _a.state, srcToken = _a.srcToken, dstToken = _a.dstToken;
    var inverted = state.isInvertedLimitPrice;
    return (0, react_1.useMemo)(function () {
        return {
            srcToken: inverted ? dstToken : srcToken,
            dstToken: inverted ? srcToken : dstToken,
        };
    }, [srcToken, dstToken, inverted]);
};
exports.useLimitTokens = useLimitTokens;
var useIsLimitInverted = function () {
    var inverted = (0, context_1.useTwapContext)().state.isInvertedLimitPrice;
    return inverted;
};
exports.useIsLimitInverted = useIsLimitInverted;
var useLimitResetButton = function () {
    var customPercent = useCustomPercent();
    var onSelectCallback = (0, exports.useOnLimitPercentageClick)();
    var onReset = (0, react_1.useCallback)(function () {
        onSelectCallback("0");
    }, [onSelectCallback]);
    return {
        value: customPercent,
        onReset: onReset,
    };
};
exports.useLimitResetButton = useLimitResetButton;
var useInvertLimit = function () {
    return actions_1.stateActions.useInvertLimit();
};
exports.useInvertLimit = useInvertLimit;
var useLimitPercentButton = function (percent) {
    var _a = (0, context_1.useTwapContext)().state, inverted = _a.isInvertedLimitPrice, limitPricePercent = _a.limitPricePercent;
    var limitPrice = (0, lib_1.useLimitPrice)().price;
    var priceDeltaPercentage = (0, lib_1.useLimitPricePercentDiffFromMarket)();
    var isSelected = (0, react_1.useMemo)(function () {
        var p = limitPricePercent || priceDeltaPercentage;
        if ((0, bignumber_js_1.default)(limitPrice || 0).isZero()) {
            return false;
        }
        return (0, bignumber_js_1.default)(p || 0).eq(percent);
    }, [limitPricePercent, limitPrice, priceDeltaPercentage, percent]);
    var text = (0, react_1.useMemo)(function () {
        return "".concat((0, bignumber_js_1.default)(percent || 0).isZero() ? "" : inverted ? "-" : !inverted && "+", " ").concat(Math.abs(Number(percent)), " %");
    }, [inverted, percent]);
    var onSelectCallback = (0, exports.useOnLimitPercentageClick)();
    var onSelect = (0, react_1.useCallback)(function () {
        onSelectCallback(percent);
    }, [onSelectCallback, percent]);
    return {
        value: percent,
        isSelected: isSelected,
        onSelect: onSelect,
        text: text,
    };
};
exports.useLimitPercentButton = useLimitPercentButton;
var useLimitPricePanel = function () {
    var isMarket = (0, lib_1.useIsMarketOrder)();
    var shouldWrapOrUnwrapOnly = (0, lib_1.useShouldWrapOrUnwrapOnly)();
    return {
        showWarning: isMarket,
        hidePanel: shouldWrapOrUnwrapOnly,
    };
};
exports.useLimitPricePanel = useLimitPricePanel;
